<template>
  <v-container fluid>
    <v-toolbar
      color="#eee"
      class="elevation-0 secondary--text mb-4"
      style="background: transparent" >
      <v-toolbar-title>Carteira Apetrus</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-flex xs2 v-if="carteira">
        <v-tooltip bottom>
          <v-btn flat slot="activator" @click="recebimentoCarteira(true)">
          <v-switch
            v-if="posto"
            v-model="posto.tem_recebimento_carteira_empresa"
            label="Recebe Empresa"
            color="primary"
            class="mt-3"
          ></v-switch>
          </v-btn>
          <div style="width: 12em; font-size: 1.2em; text-align: center;">
            {{
              tem_recebimento_carteira_empresa ? 'Com esse recurso desativo você não poderá receber Crédito Apetrus em sua carteira sobre as vendas para empresas.' :
              'Com esse recurso ativo você poderá receber Crédito Apetrus em sua carteira sobre as vendas feitas a empresas, pagando apenas uma pequena porcentagem em cima das vendas.'
            }}
          </div>
        </v-tooltip>
      </v-flex>
      <v-flex xs2 v-if="carteira">
        <v-tooltip bottom>
          <v-btn flat slot="activator" @click="recebimentoCarteira(false)">
            <v-switch
              v-if="posto"
              v-model="posto.tem_recebimento_carteira_cliente"
              label="Recebe Cliente"
              color="primary"
              class="mt-3"
            ></v-switch>
          </v-btn>
          <div style="width: 12em; font-size: 1.2em; text-align: center;">
            {{
              tem_recebimento_carteira_cliente ? 'Com esse recurso desativo você não poderá receber Crédito Apetrus em sua carteira sobre as vendas para clientes.' :
              'Com esse recurso ativo você poderá receber Crédito Apetrus em sua carteira sobre as vendas feitas a clientes, pagando apenas uma pequena porcentagem em cima das vendas.'
            }}
          </div>
        </v-tooltip>
      </v-flex>
      <v-tooltip bottom>
        <v-btn slot="activator" icon color="primary" @click="posto.chave_pix ? abrirDialogSmartlock('retirada') : avisoDoPix()" :disabled="(carteira && carteira.saldo <= 0)|| !carteira">
          <v-icon>local_atm</v-icon>
        </v-btn>
        <span>Solicitar retirada</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn slot="activator" icon color="primary" @click="abrirDialogSmartlock('transferencia')" :disabled="(carteira && carteira.saldo <= 0)  || !carteira">
          <v-icon>compare_arrows</v-icon>
        </v-btn>
        <span>Transferência</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn slot="activator" icon color="primary" @click="abrirDialogSmartlock('pix')" :disabled="!carteira">
          <v-icon>pix</v-icon>
        </v-btn>
        <span>Chave Pix</span>
      </v-tooltip>
    </v-toolbar>
    <v-card>
      <template v-if="loading">
        <v-layout fill-height justify-center align-center>
          <v-progress-circular indeterminate size="40" color="primary"></v-progress-circular>
        </v-layout>
      </template>
      <template v-else>
        <template v-if="carteira">
          <v-card-text>
            <div>
              <v-layout justify-center>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-avatar v-on="on" color="success" size="200">
                      <h1 class="white--text" v-if="carteira">{{ carteira.saldo | currency({ fractionCount: 2 }) }}</h1>
                    </v-avatar>
                  </template>
                  <span>Saldo</span>
                </v-tooltip>
              </v-layout>
            </div>
            <div>
              <div class="headline grey--text pt-3 text-xs-center pt-5 mb-2">
                Histórico
              </div>
              <span v-if="historico">
                <v-list class="mb-2">
                  <v-list-tile v-for="(transacao, index) in historico" :key="index" class="mb-2" style="border-bottom: 0.1em solid #DCDCDC;">
                    <v-list-tile-content>
                      <v-list-tile-title v-text="transacao.descricao"></v-list-tile-title>
                      <v-list-tile-sub-title :class="transacao.valor >= 0 ? 'success--text' : 'error--text'">R$ {{ transacao.valor }} ({{ transacao.data.substr(0, 10).split('-').reverse().join('/') }})</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </span>
            </div>
            <div class="text-xs-center">
              <v-pagination v-model="pagination.page" :length="pages" circle></v-pagination>
            </div>
          </v-card-text>
        </template>
        <template v-else>
          <v-card-text class="headline">
            Ainda não há carteira Apetrus vinculada a este posto. Deseja criar uma agora mesmo?
          </v-card-text>
          <v-card-actions>
            <v-btn color="success" flat @click="criarCarteiraVirtual()">
              Criar carteira Apetrus
            </v-btn>
          </v-card-actions>
        </template>
      </template>
    </v-card>
    <v-dialog v-model="dialogRetirada" width="650" v-if="autenticado && dialogRetirada">
      <dialog-solicitar-retirada @solicitarRetiradaDeSaldo="solicitarRetiradaDeSaldo" :carteira="carteira"></dialog-solicitar-retirada>
    </v-dialog>
    <v-dialog v-model="dialogPix" width="650" v-if="autenticado && dialogPix">
      <dialog-pix @cadastrarChavePix="cadastrarChavePix" :posto="posto"></dialog-pix>
    </v-dialog>
    <v-dialog v-model="dialogTransferencia" width="650" v-if="autenticado && dialogTransferencia">
      <dialog-transferencia :saldo="carteira.saldo" @transferirSaldo="transferirSaldo"></dialog-transferencia>
    </v-dialog>
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
    </v-snackbar>
    <v-dialog v-model="authenticationDialog" width="35em" v-if="authenticationDialog">
      <smart-lock @fechar="authenticationDialog = false" @callDialog="Autenticado = true"></smart-lock>
    </v-dialog>
  </v-container>
</template>
<script>
import DialogSolicitarRetirada from '@/components/dialogs/DialogSolicitarRetirada'
import DialogPix from '@/components/dialogs/DialogPix'
import DialogTransferencia from '@/components/dialogs/DialogTransferencia'
import SmartLock from '@/components/dialogs/SmartLock'

export default {
  components: {
    DialogSolicitarRetirada,
    DialogPix,
    DialogTransferencia,
    SmartLock
  },
  data () {
    return {
      autenticado: false,
      authenticationDialog: false,
      carteira: '',
      historico: '',
      dialogRetirada: false,
      dialogPix: false,
      dialogTransferencia: false,
      tem_recebimento_carteira_empresa: false,
      tem_recebimento_carteira_cliente: false,
      pagination: {
        page: 1,
        rowsPerPage: 20
      },
      totalItens: 0,
      snackbar: {
        active: false,
        color: 'info',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      }
    }
  },
  methods: {
    abrirDialogSmartlock (acao) {
      this.autenticado = false
      this.authenticationDialog = true
      switch (acao) {
        case 'pix':
          this.dialogPix = true
          break
        case 'retirada':
          this.dialogRetirada = true
          break
        case 'transferencia':
          this.dialogTransferencia = true
          break
      }
    },
    pegarCarteiraVirtual () {
      this.$store.dispatch('pegarCarteiraVirtual', { cnpj: this.posto.cnpj }).then((json) => {
        this.carteira = json
      })
    },
    pegarHistoricoDaCarteiraVirtual () {
      this.$store.dispatch('pegarHistoricoDaCarteiraVirtual', {
        page: this.pagination.page,
        id_carteira: this.carteira.id
      }).then((json) => {
        this.historico = json.results
        this.totalItens = json.count
      })
    },
    criarCarteiraVirtual () {
      this.$store.dispatch('criarCarteiraVirtual', { cnpj: this.posto.cnpj }).then((json) => {
        this.carteira = json
      })
    },
    avisoDoPix () {
      this.snackbar.text = 'Cadastre uma chave Pix antes de solicitar a retirada de saldo.'
      this.snackbar.color = 'info'
      this.dialogRetirada = false
      this.snackbar.active = true
    },
    solicitarRetiradaDeSaldo (dados) {
      this.$store.dispatch('solicitarRetiradaDeSaldo', { tipo_chave_pix: dados.tipo_chave_pix, chave_pix: dados.chave_pix, valor: dados.valor }).then((response) => {
        this.snackbar.text = 'Solicitação realizada com sucesso.'
        this.snackbar.color = 'success'
        this.dialogRetirada = false
        this.snackbar.active = true
        this.pegarCarteiraVirtual()
      }).catch(() => {
        this.snackbar.text = 'Já existe uma solicitação em aberto para sua conta.'
        this.snackbar.color = 'error'
        this.dialogRetirada = false
        this.snackbar.active = true
      })
    },
    cadastrarChavePix (dados) {
      this.$store.dispatch('cadastrarChavePix', { cnpj: this.posto.cnpj, tipo_chave_pix: dados.tipo_chave_pix, chave_pix: dados.chave_pix }).then(() => {
        this.dialogPix = false
        this.autenticado = false
        this.carregarPosto()
        this.snackbar.text = 'Chave Pix cadastrada com sucesso.'
        this.snackbar.color = 'success'
        this.snackbar.active = true
      })
    },
    carregarPosto () {
      this.$store.dispatch('escolherPosto', { cnpj: this.posto.cnpj })
    },
    snackbarSuccess (text) {
      this.snackbar.color = 'info'
      this.snackbar.text = text
      this.snackbar.active = true
    },
    snackbarError (text) {
      this.snackbar.color = 'error'
      this.snackbar.text = text
      this.snackbar.active = true
    },
    transferirSaldo (payload) {
      this.dialogTransferencia = false
      this.$store.dispatch('transferirSaldo', payload).then(() => {
        this.dialogTransferencia = false
        this.carregarPosto()
        this.snackbar.text = `${payload.valor_pago} transferidos com sucesso.`
        this.snackbar.color = 'success'
        this.snackbar.active = true
      }).catch((erro) => {
        this.dialogTransferencia = false
        this.carregarPosto()
        this.snackbar.text = erro
        this.snackbar.color = 'error'
        this.snackbar.active = true
      })
    },
    recebimentoCarteira (isEmpresa) {
      this.$store.dispatch('recebimentoCarteira', isEmpresa).then(() => {
        if (isEmpresa) {
          this.tem_recebimento_carteira_empresa = !this.tem_recebimento_carteira_empresa
          if (this.tem_recebimento_carteira_empresa) this.snackbarSuccess('Aguarde o recebimento do e-mail para poder começar a receber pela carteira.')
          else this.snackbarSuccess('Você não receberá mais da empresa pela carteira.')
        } else {
          this.tem_recebimento_carteira_cliente = !this.tem_recebimento_carteira_cliente
          if (this.tem_recebimento_carteira_cliente) this.snackbarSuccess('Aguarde o recebimento do e-mail para poder começar a receber pela carteira.')
          else this.snackbarSuccess('Você não receberá mais do cliente pela carteira.')
        }
      })
    }
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    },
    posto () {
      return this.$store.getters.posto
    },
    loading () {
      return this.$store.getters.loading
    },
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItens == null
      ) return 0

      const pages = Math.ceil(this.totalItens / this.pagination.rowsPerPage)
      return pages
    }
  },
  watch: {
    posto (val, oldval) {
      if (val) {
        this.pegarCarteiraVirtual()
        this.tem_recebimento_carteira_empresa = this.posto.tem_recebimento_carteira_empresa
        this.tem_recebimento_carteira_cliente = this.posto.tem_recebimento_carteira_cliente
      } else {
        this.carteira = null
      }
    },
    carteira (val) {
      if (val) {
        this.pegarHistoricoDaCarteiraVirtual()
      } else {
        this.historico = []
      }
    },
    pagination: {
      handler (val) {
        if (this.carteira) this.pegarHistoricoDaCarteiraVirtual()
      },
      deep: true
    }
  },
  beforeMount () {
    if (this.posto) {
      this.pegarCarteiraVirtual()
      this.tem_recebimento_carteira_empresa = this.posto.tem_recebimento_carteira_empresa
      this.tem_recebimento_carteira_cliente = this.posto.tem_recebimento_carteira_cliente
    }
  }
}
</script>
<style>
</style>
